export function clamp(value: number, min: number, max: number): number {
	return Math.min(Math.max(value, min), max);
}

export function getDeltaInMs(start: Date, end: Date): number {
	return end.getTime() - start.getTime();
}

export function calculateProgress(
	duration: number | null,
	createdAt: Date | null,
	reference: Date = new Date(Date.now()),
): number {
	if (!duration || !createdAt) {
		return -1;
	}

	const estimatedCompletion = new Date(createdAt.getTime() + duration);

	const delta = getDeltaInMs(reference, estimatedCompletion);

	return 1 - clamp(delta / duration, 0.1, 1);
}

export function zip<T, U>(a: T[], b: U[]): [T, U][] {
	if (a.length !== b.length) {
		throw new Error("Arrays must be of equal length");
	}

	// @ts-ignore
	return a.map((v, i) => [v, b[i]]);
}

export function dedupe<T>(arr: T[]): T[] {
	return Array.from(new Set(arr));
}

export function clone<T>(a: T): T {
	return JSON.parse(JSON.stringify(a)) as T;
}

export function last<T>(arr: T[]): T | undefined {
	return arr[arr.length - 1];
}

export function first<T>(arr: T[]): T | undefined {
	return arr[0];
}

export const snakeCase = (str: string): string => {
	return str
		.replace(/\W+/g, " ")
		.split(/ |\B(?=[A-Z])/)
		.map((word) => word.toLowerCase())
		.join("_");
};

export const capitalize = (str: string): string => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

export const todo = (message: string): void => {};

export function exponentialBackoff(
	retryCount: number,
	retryInterval: number,
): number {
	return retryInterval * Math.pow(2, retryCount - 1);
}

export function sleep(ms: number): Promise<void> {
	return new Promise((resolve) => setTimeout(resolve, ms));
}
